import { render } from "./Guest.vue?vue&type=template&id=5a28d1c4"
const script = {}

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Layouts/Guest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a28d1c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a28d1c4', __exports__)) {
    api.reload('5a28d1c4', __exports__)
  }
  
  module.hot.accept("./Guest.vue?vue&type=template&id=5a28d1c4", () => {
    api.rerender('5a28d1c4', render)
  })

}


export default __exports__